import React, { useEffect, useRef, useState } from 'react';
import { useTranslate } from '@tolgee/react';
import Container from '@amf/shared/components/layout/Container';
import Menu from '@amf/shared/components/menu/Menu';
import useAdvancedSearch, {
  SearchScope,
} from '@amf/shared/components/search/hooks/useAdvancedSearch';
import AdvancedSearchResults from '@amf/shared/components/search/AdvancedSearchResults';

type Props = {
  prefixes: {
    news: string;
    player: string;
    league: string;
    club: string;
    team: string;
    ground: string;
  };
};

function AdvancedSearch({ prefixes }: Props) {
  const { t } = useTranslate();
  const ref = useRef<HTMLInputElement>(null);
  const [scope, setScope] = useState(SearchScope.ALL);
  const [query, setQuery] = useState('');
  const { data, error, abort } = useAdvancedSearch(query, scope);
  useEffect(() => ref.current?.focus(), []);

  const loading = data === null && !error && query.length > 0;
  return (
    <div className='AdvancedSearch'>
      <div className='AdvancedSearch__header'>
        <Container>
          <div className='AdvancedSearch__panel'>
            <h1>{t('search.title')}</h1>
            <div className='AdvancedSearch__field'>
              <input
                ref={ref}
                type='search'
                className='AdvancedSearch__input'
                placeholder={t('search.query')}
                value={query}
                onInput={e => {
                  // @ts-ignore
                  abort();
                  setQuery(e.currentTarget.value);
                }}
                onChange={e => {
                  // @ts-ignore
                  abort();
                  setQuery(e.target.value);
                }}
              />
              <i className='bi bi-search AdvancedSearch__icon' />
            </div>
          </div>
        </Container>
      </div>
      <Menu<SearchScope>
        onChange={({ value }) => setScope(value)}
        selected={{ id: scope, title: t(`search.scope.${scope}`), value: scope }}
        items={[
          {
            id: SearchScope.ALL,
            title: t(`search.scope.${SearchScope.ALL}`),
            value: SearchScope.ALL,
          },
          {
            id: SearchScope.NEWS,
            title: t(`search.scope.${SearchScope.NEWS}`),
            value: SearchScope.NEWS,
          },
          {
            id: SearchScope.LEAGUES,
            title: t(`search.scope.${SearchScope.LEAGUES}`),
            value: SearchScope.LEAGUES,
          },
          {
            id: SearchScope.PLAYERS,
            title: t(`search.scope.${SearchScope.PLAYERS}`),
            value: SearchScope.PLAYERS,
          },
          {
            id: SearchScope.TEAMS,
            title: t(`search.scope.${SearchScope.TEAMS}`),
            value: SearchScope.TEAMS,
          },
          {
            id: SearchScope.CLUBS,
            title: t(`search.scope.${SearchScope.CLUBS}`),
            value: SearchScope.CLUBS,
          },
          {
            id: SearchScope.GROUNDS,
            title: t(`search.scope.${SearchScope.GROUNDS}`),
            value: SearchScope.GROUNDS,
          },
        ]}
      />
      <Container>
        {query.length > 0 && (
          <AdvancedSearchResults results={data ?? []} loading={loading} prefixes={prefixes} />
        )}
      </Container>
    </div>
  );
}

export default AdvancedSearch;
